/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Bernard REDARES
 * @date        17/05/2023 09:41
 * @copyright   Copyright (c) 2002-2023 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

import { createRoot } from '@wordpress/element'
import AdvancedSearchClient from './components/AdvancedSearchClient'
import { SearchEngine } from './components/SearchEngine'
import ModalService from './services/modal.service'

document.addEventListener('DOMContentLoaded', () => {
    new ModalService()
    let advancedSearchClientInitialized = false

    document.addEventListener('irisadvancedsearchload', () => {
        if (!advancedSearchClientInitialized) {
            window.advancedSearchClient = new AdvancedSearchClient(() => {
                for (const element of document.querySelectorAll(
                    '[data-iris-advanced-search-search]',
                )) {
                    createRoot(element).render(<SearchEngine />)
                }
            })
            advancedSearchClientInitialized = true
        }
    })
})
